import BaseService from './base.service';

export default class MedicalFacility extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getMedicalFacilityHome = query => {
        return this.get('/medical-facility', query);
    };

    getMedicalFacilityById = (businessId, query) => {
        return this.get(`/medical-facility/${businessId}`, query);
    };
}
